export enum UserPermissions {
  View = 1,
  Modify = 2,
  Export = 3,
  Print = 4,
  Add = 5,
  Delete = 6,
}
